<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Purchases",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
    ExcelExport,
  },
  data() {
    return {
      title: "Store Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Store Purchases Report",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsStorePurchaseServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      returnData: {
        purchase_id: "",
        product_id: "",
        product_name: "",
        quantity: "",
        unit_price: "",
        unit_sellingprice: "",
        unit: "",
        batch: "",
        expiry: "",
        supplier_id: "",
        invoiceno: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        mode: "",
        type: 1,
      },
      edit: {
        id: "",
        total: "",
        paid: "",
        mode: "",
      },
      deleteData: {
        id: "",
      },
      editData: {
        id: "",
      },
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        branch_id: 0,
        invoiceno: "",
      },
      amountError: "",
      modeError: "",
      reasonError: "",
      returnModeError: "",
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "StorePurchases",
      "PurchasesReturn",
      "StorePurchasesPagination",
      "StorePurchasesSummary",
      "FilterStatus",
      "StorePurchasesPaginated",
    ]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings"]),
    ...mapActions("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("store", ["StorePdts"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),

    purchaseColumns() {
      const cols = [
        { key: "sn", label: "S/N" },
        { key: "product", label: "PRODUCT" },
        { key: "qty", label: "QTY" },
        { key: "price", label: "PRICE" },
      ];

      if (this.GeneralSettings.track_expiries) {
        cols.push({ key: "batch", label: "BATCH" });
        cols.push({ key: "expiry", label: "EXPIRY" });
      }

      cols.push(
        { key: "status", label: "STATUS" },
        { key: "totAmt", label: "TOTAL" },
        { key: "amtPaid", label: "PAID" },
        { key: "discount", label: "DISCOUNT" },
        { key: "supplier", label: "SUPPLIER" },
      );

      if (this.GeneralSettings.capture_purchase_invoiceno) {
        cols.push({ key: "invoiceno", label: "INVOICE NO" });
      }

      cols.push(
        { key: "date", label: "DATE" },
        { key: "actions", label: "ACTIONS", tdClass: "text-nowrap" },
      );

      return cols;
    },

    rows() {
      return this.IsStorePurchaseServerPaginated
        ? this.StorePurchasesPagination?.total
        : this.StorePurchases
        ? this.StorePurchases.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStorePurchaseServerPaginated) {
          return (
            this.StorePurchasesPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStorePurchaseServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchPurchases(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StorePurchasesPaginated && this.StorePurchasesPagination
          ? this.StorePurchasesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StorePurchasesPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.StorePurchasesSummary || {
          totalAmount: 0,
          totalPaid: 0,
          totalDiscount: 0,
          totalBalance: 0,
        }
      );
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPurchases: "purchase/fetchStorePurchases",
      EditPaid: "purchase/editAmtPaidMode",
      EditPurchase: "purchase/editPurchase",
      DeletePurchase: "purchase/deletePurchase",
      FetchModes: "setting/fetchPaymentOptions",
      FetchReturns: "purchase/fetchReturns",
      SaveReturn: "purchase/returnStorePurchase",
      FetchSuppliers: "stock/fetchSuppliers",
      StoreItems: "store/fetchStorePdts",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsStorePurchaseServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      return m != null && m !== ""
        ? m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : m;
    },
    resetModal() {
      this.edit.id = "";
      this.edit.total = "";
      this.edit.paid = "";
      this.edit.mode = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    showEditModal(row) {
      this.editData.id = row.id;
    },
    showDeleteModal(row) {
      this.deleteData.id = row.id;
    },
    addCommas() {
      this.edit.paid = this.thousandSeperator(this.edit.paid);
    },
    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.mode = data.payments[0].mode;
      this.edit.total = data.totAmt;
      this.edit.paid = this.thousandSeperator(data.amtPaid);
    },
    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.edit.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.edit.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.EditPaid(this.edit);
    },
    editPurchase(modalId) {
      this.modal_id = modalId;
      this.EditPurchase(this.editData);
    },
    deletePurchase(modalId) {
      this.modal_id = modalId;
      this.DeletePurchase(this.deleteData)
        .then(() => {
          this.FetchPurchases(this.data);
          this.closeModal(modalId);
        })
        .catch(() => {
          this.FetchPurchases(this.data);
          this.closeModal(modalId);
        });
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    Receipt_print(Id) {
      this.$router.push(`/purchasesreceipt/${btoa(Id)}`);
    },
    Showreturn_modal(data) {
      this.returnData.purchase_id = data.purchase.id;
      this.returnData.product_id = data.product_id;
      this.returnData.product_name = data.product;
      this.returnData.unit_price = data.unitPrice;
      this.returnData.unit_sellingprice = data.SPrice;
      this.returnData.quantity = data.qty;
      this.returnData.unit = data.unit_id;
      this.returnData.batch = data.batch || "";
      this.returnData.expiry = data.expiry || "";
      this.returnData.supplier_id = data.purchase.supplier_id;
      this.returnData.invoiceno = data.purchase.invoiceno || "";
    },
    resetSave() {
      // this.resetErrors();
      this.returnData.purchase_id = "";
      this.returnData.product_id = "";
      this.returnData.product_name = "";
      this.returnData.quantity = "";
      this.returnData.unit_price = "";
      this.returnData.unit_sellingprice = "";
      this.returnData.unit = "";
      this.returnData.batch = "";
      this.returnData.expiry = "";
      this.returnData.supplier_id = "";
      this.returnData.invoiceno = "";
      this.returnData.reason = "";
      this.returnData.date = moment(new Date()).format("YYYY-MM-DD");
      this.reasonError = "";
      this.returnModeError = "";
      this.modal_id = "";
    },
    Return_purchase() {
      // Reset errors
      this.reasonError = "";
      this.returnModeError = "";

      // Validate reason
      if (!this.returnData.reason || this.returnData.reason.trim() === "") {
        this.reasonError = "Reason is required";
        return;
      }

      // Validate mode
      if (!this.returnData.mode || this.returnData.mode === "") {
        this.returnModeError = "Payment Option is required";
        return;
      }

      this.modal_id = "return-purchase-modal";
      // Call SaveReturn and handle backend response
      this.SaveReturn(this.returnData)
        .then(() => {
          this.closeModal(this.modal_id);
          this.FetchPurchases(this.data);
        })
        .catch(() => {
          this.closeModal(this.modal_id);
          this.FetchPurchases(this.data);
        });
    },

    filterReport() {
      this.clientCurrentPage = 1;
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.serverPerPage;
      this.FetchPurchases(payload);
    },

    handlePageChange(newPage) {
      if (this.IsStorePurchaseServerPaginated) {
        this.data.page = newPage;
        this.FetchPurchases(this.data);
      }
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the store purchase data. Please try again.",
        confirmButtonText: "OK",
      });
    },
  },
  created() {
    this.FetchPurchases(this.data);
    this.FetchModes();
    this.FetchReturns();
    this.FetchGeneralSettings();
    this.FetchSuppliers();
    this.StoreItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="
                    Branches
                      ? [{ id: 0, name: 'All Branches' }, ...Branches]
                      : []
                  "
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-3">
                <!-- <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                > -->
                <ExcelExport
                  endpoint="export_storepurchases"
                  filename="storepurchases_report.xlsx"
                  :payload="data"
                  button-text="Export"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                <model-list-select
                  :list="StorePdts ? StorePdts : []"
                  v-model="data.product"
                  option-value="product_id"
                  option-text="product_name"
                  placeholder="Select Product"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIERS</label>

                <model-list-select
                  :list="Suppliers ? Suppliers : []"
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>INVOICE NO.</label>
                <input
                  class="form-control"
                  v-model="data.invoiceno"
                  placeholder="Enter Invoice No"
                  @keyup.enter="filterReport()"
                />
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    variant="light"
                    small
                    role="status"
                    v-show="FilterStatus"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="purchaseColumns"
                :rows="StorePurchases"
                :total-rows="rows"
                :pagination="StorePurchasesPagination"
                :server-pagination="IsStorePurchaseServerPaginated"
                :loading="SaveStatus"
                row-class="purchase-table-bordered"
              >
                <!-- S/N -->
                <template #cell(sn)="{ index }">
                  {{ StorePurchasesPagination.from + index }}
                </template>

                <!-- PRODUCT -->
                <template #cell(product)="{ row }">
                  <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                    {{ det.product }}
                  </div>
                </template>

                <!-- QTY -->
                <template #cell(qty)="{ row }">
                  <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                    {{ det.qty }}{{ det.usymbol }}
                  </div>
                </template>

                <!-- UNIT PRICE -->
                <template #cell(price)="{ row }">
                  <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                    {{ det.unitPrice ? thousandSeperator(det.unitPrice) : 0 }}
                  </div>
                </template>

                <!-- BATCH -->
                <template #cell(batch)="{ row }">
                  <div v-if="GeneralSettings.track_expiries">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.batch }}
                    </div>
                  </div>
                </template>

                <!-- EXPIRY -->
                <template #cell(expiry)="{ row }">
                  <div v-if="GeneralSettings.track_expiries">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.expiry }}
                    </div>
                  </div>
                </template>

                <!-- STATUS / RETURN -->
                <template #cell(status)="{ row }">
                  <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                    <b-button
                      v-if="det.Returned == 1"
                      size="sm"
                      variant="secondary"
                      disabled
                    >
                      Returned
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="primary"
                      v-b-modal.return-purchase-modal
                      @click="Showreturn_modal(det)"
                    >
                      Return
                    </b-button>
                  </div>
                </template>

                <!-- TOTAL -->
                <template #cell(totAmt)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <!-- PAID -->

                <template #cell(amtPaid)="{ row, value }">
                  <span
                    class="text-warning"
                    v-b-modal.expired-modal
                    style="cursor: pointer"
                    @click="ShowEdit(row)"
                    v-if="row.numpaid == 1"
                  >
                    {{ thousandSeperator(row.amtPaid) }}
                  </span>
                  <span v-else>
                    {{ thousandSeperator(row.amtPaid) }}
                  </span>
                </template>

                <!-- DISCOUNT -->
                <template #cell(discount)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <!-- SUPPLIER -->
                <template #cell(supplier)="{ value }">
                  {{ value || "N/A" }}
                </template>

                <!-- INVOICE NO (if enabled) -->
                <template
                  v-if="GeneralSettings.capture_purchase_invoiceno"
                  #cell(invoiceno)="{ row }"
                >
                  {{ row.invoiceno }}
                </template>

                <!-- DATE -->
                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <!-- ACTIONS -->
                <template #cell(actions)="{ row }">
                  <div>
                    <b-dropdown
                      text="More Actions..."
                      size="sm"
                      class="btn-primary"
                    >
                      <b-dropdown-item
                        v-b-modal.delete-purchase-modal
                        @click="showDeleteModal(row)"
                      >
                        <i class="fa fa-trash text-danger"></i>
                        <span class="text-danger">Delete</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-b-modal.edit-purchase-modal
                        @click="showEditModal(row)"
                        ><i class="fa fa-edit text-primary"></i>
                        <span class="text-primary">Edit</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        variant="info"
                        @click="Receipt_print(row.id)"
                        ><i class="fa fa-download"></i>Reprint</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-3">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Paid:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalPaid)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Discount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalDiscount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalBalance)
                    }}</span>
                  </h5>
                </div>
              </div>

              <!-- modal starts -->
              <b-modal
                id="return-purchase-modal"
                hide-footer
                @hidden="resetSave"
              >
                <template #modal-title> Return New Item </template>
                <div class="form-group mb-3">
                  <label>Return Date</label>
                  <div class="input-group">
                    <input
                      type="date"
                      placeholder="Enter Date"
                      class="form-control"
                      v-model="returnData.date"
                    />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Quantity</label>
                  <div class="input-group">
                    <input
                      type="number"
                      placeholder="Enter quantity"
                      class="form-control"
                      v-model="returnData.quantity"
                    />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Reason <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <textarea
                      type="text"
                      placeholder="Enter reason"
                      class="form-control"
                      v-model="returnData.reason"
                      @input="reasonError = ''"
                    ></textarea>
                  </div>
                  <div class="text-danger" v-if="reasonError">
                    <em>{{ reasonError }}</em>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label
                    >Payment Option <span class="text-danger">*</span></label
                  >
                  <div class="input-group">
                    <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="returnData.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Mode"
                      @input="returnModeError = ''"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="returnModeError">
                    <em>{{ returnModeError }}</em>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('return-purchase-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="Return_purchase()"
                  >
                    <i class="fa fa-check"></i>
                    Submit
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">
          Edit Amount Paid For Purchase of {{ thousandSeperator(edit.total) }}
        </h4></template
      >
      <label>Amount Paid</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="edit.paid"
          placeholder="Quantity removed"
          @input="resetError(), addCommas()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select
          :list="PaymentOptions ? PaymentOptions : []"
          v-model="edit.mode"
          option-value="id"
          option-text="mode"
          placeholder="Select Method"
          @input="resetError()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="editAmt('expired-modal')"
        >
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
      header-bg-variant="warning"
      header-text-variant="light"
      body-text-variant="warning"
      footer-bg-variant="warning"
      footer-text-variant="warning"
      id="edit-purchase-modal"
      hide-footer
      @hidden="resetEdit"
    >
      <template #modal-title> Edit Purchase</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to return and edit this Purchase? Click Proceed Button
            to Return Purchase for Editing.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('edit-purchase-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editPurchase('edit-purchase-modal')"
        >
          <i class="fa fa-edit"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-purchase-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Purchase</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to delete this Purchase? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-purchase-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deletePurchase('delete-purchase-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
